import { useCallback } from 'react';
import * as state from '@/state';
import { transformFromAlignedBox, VisibilityBoxMode, VisibilityBoxProps } from '@abyss/3d-viewer';
import { DEFAULT_VISIBILITY_BOX_STYLE } from '@/constants';
import { useAtomValue, useSetAtom } from 'jotai';

export const useZoneVisibilityBox = () => {
  const selectedZone = useAtomValue(state.selectedZone);
  const setCurrentVisibilityBox = useSetAtom(state.currentVisibilityBox);

  const setDefaultZoneVisibilityBox = useCallback(() => {
    const box = selectedZone?.box;
    if (box) {
      const visibilityBox: VisibilityBoxProps = {
        ...transformFromAlignedBox({
          min: [box.min.x, box.min.y, box.min.z],
          max: [box.max.x, box.max.y, box.max.z],
        }),
        mode: VisibilityBoxMode.Enabled,
        step: [0.25, 0.25, 0.1],
        style: DEFAULT_VISIBILITY_BOX_STYLE,
      };
      setCurrentVisibilityBox(visibilityBox);
    }
  }, [selectedZone, setCurrentVisibilityBox]);

  return { setDefaultZoneVisibilityBox };
};
